<template >
    <div class="_info_pessoais_container">
        <v-card-text>
            <strong> Dados Pessoais</strong>
        </v-card-text>

        <v-chip class="_info_pessoais_pink" color="pink">Nome: {{ estudante ? estudante.nome : '' }}</v-chip><br>
        <v-chip class="_info_descricao_grey">Genero:<strong>{{ estudante ? estudante.sexo : '' }}</strong></v-chip><br>
        <v-chip class="_info_descricao_grey">Data de Nascimento:<strong>{{ estudante ? estudante.datanascimento : '' }}</strong></v-chip><br>
        <v-chip class="_info_descricao_grey">Natural de :<strong>{{ estudante ? estudante.provincia : '' }}</strong></v-chip><br>
        <v-chip class="_info_descricao_grey">BI:<strong>{{ estudante ? estudante.bi : '' }}</strong></v-chip><br>
        <v-chip class="_info_descricao_grey">Filho de :<strong>{{ estudante ? estudante.nomedopai : '' }}</strong></v-chip><br>
        <v-chip class="_info_descricao_grey">e De:<strong>{{ estudante ? estudante.nomedamae : '' }}</strong></v-chip><br>
        <v-chip class="_info_descricao_grey">Contacto:<strong>{{ estudante ? estudante.telefone : '' }}</strong></v-chip><br>
        <v-chip color="pink" class="_info_pessoais_pink">Matricula:{{ estudante ? estudante.idMatricula : '' }}</v-chip><br>
        <v-chip color="pink" class="_info_pessoais_pink"> Instituição Inscrito : {{ estudante ? estudante.instituicao : '' }}</v-chip><br>
    </div>
</template>
<script>

export default {
    name: 'informacoesPessoais',
    props: ['estudante']
}
</script>
<style>

._info_pessoais_container {
    padding: 2px;
}

._info_pessoais_pink {
    padding: 2px;
    color:white !important;
    margin-bottom: 3px;
}

._info_descricao_grey {
    margin-bottom: 3px;
}

</style>